/* rsa加密 */
import JSEncrypt  from "jsencrypt";
console.log(JSEncrypt)
/* 加密手机号邮箱 */
export function encryptStr(str, type) {
  var rsa = new JSEncrypt();
  var rsaKey =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrIqFb8i6Qw9ETZilOQNP8eTdV0UJm1ToOa5G146lF/Ik14ZNwx0hmdK4a8X35DAa2fmYlZD5Jt+1qzh6GsHI6n119NSQgH5QKaQ0RKeDxkJux/RZv0bcEE9dqP0erX2DtMJ46Rt5eT2Qnp7myTUF57+4+d6LEX0bObQ5BdrGWgwIDAQAB";
  // 身份证
  if (type == 1) {
    rsaKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC57Xz7boiVNkDcpHr5nSK/xhoxJBv34Es5ZAKCe2k0K2lMXdNTTvwkaWYJnaMho3tM9m1ZHY22HFiekrhNhsMXvDxTCgeXgHu7PpHfkQSxPRPlg2ST/N9le8vyvzoIaw8A1Ej9TQW4XMhB9G5ZIwLemP+Ez3nct5/TqIMyMF/ftwIDAQAB`;
  } else if (type == 2) {
    //银行卡
    rsaKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCVISPOlWtV/uLq4kSSvmuyfgJ1KsB0DgYXPls0Wcy05xxUkA7gcxD3q8ROD/2eKr/uwpC+ij9uLuAm4LBtbkcpfWicmBtGmVe9GWHV+6mHXOkkg4Z+u3p0cM3POH2IcwKNSmp/ba5rKy605c+wznluD8p6Qoapb80Mp8+ixkObDwIDAQAB`;
  }
  rsa.setPublicKey(rsaKey);
  let data = rsa.encrypt(str);
  return data;
}
/* 解密 */
export function decrypt(str, type) {
  var rsa = new JSEncrypt();
  var rsaKey =
    "MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAIZ9XTAswCYP5JTve7ORavbMoj2+Zr2NnC9jK1ievbpMlW70wjD+MkgSpdNBUDCVBUDGi4vEoxWFiieU2HtTMks7pawFdyujv+zybtZmv3/BTMoOC3RY1Up0XhUftkxAjkZyDvUGDyLbvKQWR26W6qlYv2c+F+R44i+n4+1tT0aPAgMBAAECgYEAgfNOgQcsn1qJ9zM0Jv1jCpgOSHTa11umx88eCiJQl1v6pFzR6v8j3KpQGsGoV1kW21E9c08MefYv2TEkwH1SQRxaIlDRqXuHQifMrG9qyxIbHmXlFELOY7bZjfxB+B4qZuM+8rT8Yfx6NTSEhMr2F1SI/+o7YVWLfjtOaAWwlSkCQQDhBvbeQ2to9cPla/Flrb2eOODHt8ASRVXW8afFNf2wvR2N1l/2GgrOmisTQV/ylUOpjw++tFLNtisN5iucoijlAkEAmQA6wSAqyeuZKTesnPHHdBhy9nyr8biNupYGzPf5uwTCfi9+nzZA15Kuccfpmvq5RXsKMYCWvQhzpkhGEMo+YwJACs8W1J5Qbn4/pqmEsumhjhQVWAKPi1EhSm3ZLTPmt7Kd1M5TVbLyifIF16rwPOrGkUJ58yMeRxtU/hnsRl3TsQJAP/Zumape+Qc7gpW53ereHVTTSuSX5XfoGGb79Nh+WIcG4EXuw5SkyvqRXxPaP2Yt6jQj8Mn3OpO79XolgINsTQJAOJQ2bWZPgAC400hkZ9IYhRR+I9aFcNynl93yUvS++FUbegsRLaeGxzh55n3bYnqHF2jqVxBoWCFziAW/rTVmUw==";
  if (type == 1) {
    rsaKey = `MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAK2VRlmjjgmQT+PSajW7S//Ur0oMQTHyCRxKjUz4IFajyICTLPk7lHNnqHhCBJkyL82ZB1KhvGrNOM2/wPNTqofzXRb4dBUpYPlqCZqVoNj2qSHbPDhCIZnILTNOl5E1OxCwHpPykytxhLmQXobCc56VGN3aLpG2dR9A+b5L88NjAgMBAAECgYEAgR2EErEhueNqSV/+OLF0unsNV9r9s5UBSdX6fMIj684wGdNfpJO4vI7iNXGF0h4OiLPHSqObbyXvlruHXndhZDr7rZYxpvfb2dSw1nq0rct0vXKQ/0AnVru4EFbBXc9IIxqlAKXoYrB/58+vGVi9auNZchkK0YkTlZ2itycO2KECQQDr+eB2XqlQuDvQdm8jKHZLVCs6spKd98YupfWOvEJh2cHo932+YgzyXLxowC2ts0fbZpoME7WVL0J+GRYx9Bs1AkEAvFAIDdcspwHW00OqmUsy7ARb0Qx2eg3Eth+uboiVVuNtY9tXxPBQANADoHNio77ezFOwNDXRat875BYXfKyfNwJAN7HmVInLFI4nL/CEEpw+L1FSUqxLBpWwZNoutt2gHVA0ADRJrWGfBKT2oxKYtWKXFyWEPk14khlxbCmnn2qp8QJAOaYKgSoxSkM+39gkPt+NjEFdVmcJUh4q7VJPlRkNFtdy4pIAkZK7+zOzGIiaVuSU0lqAY8th++SxMgctU4aJCwJAesFvEmpxNEP1EtGrVlmehRXMbIA28zBG1Pi8WnH9Xu2cMM1e5wddzxXLF5xp1nCelUbMG0TUbvOWqXLpZJ39VA==`;
  } else if (type == 2) {
    rsaKey = `MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBANwGW74fXahTGXVYhI81Kzqo1wKw3N8khdwJD1QStPIQlgBSO+RVzg/Zt7Kxn9t/QfTjbmX7JkdoYtP0occgQuHXrL3RfLA8SkUW+SnY6DQfTdWAu/rACjeJK7qJ1t+C6HPPnx44Ye0OhSG5px3QLPlmOhW8PnCm4MUvO2Fa3hY5AgMBAAECgYEAqYxkyf9Vps5SgfCyRcDNDSjqdvJfYby9Qi/hFgJMWXSagqjb6jqMzf4R5qul6fkIlHNlsUR13PT9oyOSPuYHYp+PZiWh8NY+UQMJc2ZuenYMGCaEY+pH6YhPwZ6obelJd299Sa1I6YfUvHC7+8xZgpHj1QHYYtdVIIGvA1dHiQECQQDuArSZ9q/F6GsvcE3o5zwxiwPti9fOb5bUQW/4DlzJxqr6YHzycrXOIvXo0HfDfEFuRlPeuvEa7qyHY2f0NyuJAkEA7KelFjBFTMoYl590ekeL0oROMNWhZ4hW4Qzp463yFS4Rf7RzSyHh6hXuMDJD1DGM5PN9OJkzXpuWd3yfrSN5MQJBAM7DcOtTv205NGw4rqYGw2bysk3Zr3d5v1jTJBclOvxa50utKL5iYogaHPDMsU4Ukq7ez5ttYWkZMK5I8BTbHKkCQGnOZlPuTv2PGcGojBYjqNL9TkwtJ1W3skg6UtP1sFdh2ncDQczkoDHdjjnEL2lOohS2/FRywnHZFEPl1yo8wvECQQCLI3gBm3oL61IlqndxzMbU7R/nGeXGqBS8i9+VOjmAX8xgqAGZg2iaGEQOBCoEFVTYLWAEbo/6wxR4xS0EiE16`;
  }
  rsa.setPrivateKey(rsaKey);
  let data = rsa.decrypt(str);
  return data;
}
/**
 * 判断是否为空
 */
export function validatenull(val) {
  if (typeof val === "boolean") {
    return false;
  }
  if (val instanceof Array) {
    if (val.length === 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === "{}") return true;
  } else {
    if (
      val === "null" ||
      val == null ||
      val === "undefined" ||
      val === undefined ||
      val === ""
    )
      return true;
  }
  return false;
}
/**
 *  六位以上 字母数字符号随意组合   至少两种
 */
export function isPwd(val) {
  let reg = new RegExp(
    /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-zA-Z]|[0-9]){6,18}$/
  );
  if (val == null || val.length < 6) {
    return false;
  }
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}
/**
 *  验证手机号：11位，以1开头，其余10位是数字
 */
export function isMobile(val) {
  let reg = new RegExp(/^0?(13|15|17|18|14)[0-9]{9}$/);
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

/*
 * 验证qq
 */
export function isQQ(val) {
  let reg = new RegExp(/[1-9][0-9]{4,10}/);
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}
/**
 *  验证邮箱
 */
export function isEmail(val) {
  let reg = new RegExp(/^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/);
  if (val == null || val.length < 6) {
    return false;
  }
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}
/*
 验证身份证号
*/
export function isidNo(val) {
  let reg = new RegExp(
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
  );
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}
/* 验证银行卡
 */
export function isAccount(val) {
  let reg = new RegExp(/^[0-9]*$/);
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}
/**
 * 验证是否登录
 */
export function isLogin() {
  let token = localStorage.getItem("rock-Token");
  if (validatenull(token)) {
    return false;
  } else {
    return true;
  }
}
/* 时间 */
export function getDayDate(dbl) {
  if (validatenull(dbl)) {
    return;
  }
  let date = new Date(dbl - 0);
  let Y = date.getFullYear() + ".";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + ".";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  return Y + M + D;
}
/* 设置cookie */
export function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return arr[2];
  else return null;
}

export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
